import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  CreateProjectAccessControlUsers,
  createProjectAccessControlUsers,
  deleteProjectAccessControlUsers,
  getProjectAccessControlUsers,
  updateProjectAccessControlUsers
} from '../../api/project-access-control-users';
import { AccessControl } from '../MasterData/AccessControl/accessControlSlice';

export const getProjectAccessControlUsersAsync = createAsyncThunk(
  'projectAccessControlUsers/getProjectAccessControlUsers',
  getProjectAccessControlUsers
);

export const createProjectAccessControlUsersAsync = createAsyncThunk(
  'projectAccessControlUsers/createProjectAccessControlUsers',
  async (
    {
      projectId,
      projectAccessControlUsers: createAccessControlUser
    }: CreateProjectAccessControlUsers,
    thunkAPI
  ) => {
    const projectAccessControlUsers = await createProjectAccessControlUsers({
      projectId,
      projectAccessControlUsers: createAccessControlUser
    });
    thunkAPI.dispatch(getProjectAccessControlUsersAsync(projectId));
    return projectAccessControlUsers;
  }
);

export const updateProjectAccessControlUsersAsync = createAsyncThunk(
  'projectAccessControlUsers/updateProjectAccessControlUsers',
  async (
    {
      projectId,
      projectAccessControlUsers: updateAccessControlUser
    }: CreateProjectAccessControlUsers,
    thunkAPI
  ) => {
    const projectAccessControlUsers = await updateProjectAccessControlUsers({
      projectId,
      projectAccessControlUsers: updateAccessControlUser
    });
    thunkAPI.dispatch(getProjectAccessControlUsersAsync(projectId));
    return projectAccessControlUsers;
  }
);

export const deleteProjectAccessControlUsersAsync = createAsyncThunk(
  'projectAccessControlUsers/deleteProjectAccessControlUsers',
  async (
    { projectId, userId }: { projectId: number; userId: number },
    thunkAPI
  ) => {
    await deleteProjectAccessControlUsers({
      projectId,
      userId
    });
    thunkAPI.dispatch(getProjectAccessControlUsersAsync(projectId));
  }
);

export interface ProjectAccessControlUser {
  userId: number;
  accessControls: AccessControl[];
}

interface ProjectAccessControlUserState {
  data: ProjectAccessControlUser[];
}

const initialState: ProjectAccessControlUserState = {
  data: []
};

export default createSlice({
  name: 'projectAccessControlUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getProjectAccessControlUsersAsync.fulfilled,
      (state, action) => {
        state.data = action.payload;
      }
    );
  }
});
